/**
 * Category API - public list + admin CRUD. Uses shared api instance and central endpoints.
 */
import api from '../utils/api';
import { ENDPOINTS } from '../config/endpoints';

const { CATEGORIES } = ENDPOINTS;

export const getCategories = () => api.get(CATEGORIES.LIST);
export const getCategoryById = (id) => api.get(CATEGORIES.byId(id));
export const createCategory = (data) => api.post(CATEGORIES.LIST, data);
export const updateCategory = (id, data) => api.put(CATEGORIES.byId(id), data);
export const deleteCategory = (id) => api.delete(CATEGORIES.byId(id));
export const duplicateCategory = (id) => api.post(CATEGORIES.duplicate(id));
